import { gql } from '@apollo/client';

const DELETE_OLA = gql`
  mutation DeleteOLA($olaID: String!, $pathName: String!) {
    deleteOLA(olaID: $olaID, pathName: $pathName)
  }
`;

export default DELETE_OLA;